import script from "./OperePage.vue?vue&type=script&setup=true&lang=js"
export * from "./OperePage.vue?vue&type=script&setup=true&lang=js"

import "./OperePage.vue?vue&type=style&index=0&id=0c6171b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c6171b0"]])

export default __exports__